import { Component, Input } from '@angular/core';
import { InformationText } from '@shared/models/question-types/information-text';
import { QuestionBaseComponent } from '../question-base/question-base.component';

@Component({
  selector: 'app-information-text',
  imports: [QuestionBaseComponent],
  templateUrl: './information-text.component.html',
  styleUrl: './information-text.component.scss',
})
export class InformationTextComponent {
  @Input({ required: true }) question!: InformationText;
  @Input() isFirstQuestion: boolean = false;
}
